import React from 'react';

import { Show } from 'components/Condition';

import { time } from 'utils';

type Props = {
  from?: nil | string;
  to?: nil | string;
};

export function TimeRange(props: Props) {
  const from = props.from && time(props.from, 'datetime').parse();
  const to = props.to && time(props.to, 'datetime').parse();

  let isOneDay = false;

  if (from && to) {
    isOneDay = from.val.isSame(to.val, 'day');
  }

  const formattedFrom: AnyFunction | any = (from && from.format('shortDate')) || '';

  const formattedTo: AnyFunction | any = (to && to.format('shortDate')) || '';

  if (isOneDay) {
    return <>{formattedFrom}</>;
  }

  return (
    <>
      <Show if={!!from && !to}>
        <React.Fragment>{formattedFrom}</React.Fragment>
      </Show>
      <Show if={!!to && !from}>
        <React.Fragment>- {formattedTo}</React.Fragment>
      </Show>
      <Show if={!!to && !!from}>
        <React.Fragment>
          {formattedFrom} - {formattedTo}
        </React.Fragment>
      </Show>
    </>
  );
}
